module.exports = __webpack_public_path__ + "img/frasagal05.12ab3e98.png";